export * from '@fhs/routing/src/routes/(tabs)/rewards/birthday';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/birthday';
